import { Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../../store/auth';
import { getMyOrders } from '../../api/orders';
import styles from './OrderHistoryPage.module.css';

const STATUS_COLORS: Record<string, string> = {
  pending_payment: '#e65100', confirmed: '#1565c0', processing: '#6a1b9a',
  shipped: '#00838f', delivered: '#2e7d32', cancelled: '#c62828',
};

export default function OrderHistoryPage() {
  const { t } = useTranslation();
  const accessToken = useAuthStore(s => s.accessToken);
  if (!accessToken) return <Navigate to="/login" state={{ from: '/orders' }} replace />;

  const { data, isLoading } = useQuery({ queryKey: ['my-orders'], queryFn: getMyOrders });

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>{t('orders.title')}</h1>
      {isLoading ? (
        <div className={styles.loading}>{t('common.loading')}</div>
      ) : !data?.orders?.length ? (
        <div className={styles.empty}>
          <p>{t('orders.empty')}</p>
          <Link to="/catalogue" className={styles.shopBtn}>Start Shopping</Link>
        </div>
      ) : (
        <div className={styles.list}>
          {data.orders.map((order: Record<string, unknown>) => (
            <div key={order.id as string} className={styles.order}>
              <div className={styles.orderMeta}>
                <span className={styles.orderId}>{t('orders.order_id')}{(order.id as string).slice(0, 8).toUpperCase()}</span>
                <span className={styles.date}>{new Date(order.createdAt as string).toLocaleDateString('en-IN')}</span>
              </div>
              <div className={styles.orderInfo}>
                <span className={styles.total}>₹{(order.total as number).toLocaleString('en-IN')}</span>
                <span
                  className={styles.status}
                  style={{ background: STATUS_COLORS[order.status as string] + '20', color: STATUS_COLORS[order.status as string] }}
                >
                  {t(`orders.status_${order.status}`)}
                </span>
                <Link to={`/orders/confirmation/${order.id}`} className={styles.viewBtn}>{t('orders.view_details')}</Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
